import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlFormLabelProps } from './form.props';
import { getGlobalStyleSheets } from '../../global-styles';
import { Sizes, enumAttributeConverter, SizesValuesMap } from '../enum-types';
import { AtlantisEvent, IClassMap } from '../helpers';
import { classMap } from 'lit/directives/class-map.js';

import * as TagNames from './form.tagnames';

@customElement(TagNames.FormLabel)
export class AtlFormLabel extends LitElement implements AtlFormLabelProps {
   declare labelFor: string;
   declare size?: Sizes;
   declare isHidden?: boolean;
   declare labelClass?: string;
   declare overrideClass?: boolean;

   declare _hasContent?: boolean;

   static properties = {
      labelFor: { type: String, attribute: 'label-for' },
      size: { type: String, convertor: enumAttributeConverter(Sizes) },
      isHidden: { type: Boolean, attribute: 'is-hidden' },
      labelClass: { type: String, attribute: 'label-class' },
      overrideClass: { type: Boolean, attribute: 'override-class' },

      _hasContent: { type: Boolean, state: true },
   };

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: inline-block;
         }
      `,
   ];

   private _handleSlotChange = (
      event: AtlantisEvent<Event, HTMLSlotElement>
   ) => {
      const slot = event.target;
      const assignedNodes = slot.assignedNodes({ flatten: false });
      this._hasContent = assignedNodes.length > 0;
   };

   render() {
      const slotContent = html`<slot
         @slotchange=${this._handleSlotChange}
      ></slot>`;

      if (!this._hasContent) return slotContent;

      const classNames: IClassMap = {
         'form-label': this.overrideClass !== true,
         'visually-hidden': this.isHidden === true,
      };

      if (this.size) {
         classNames[SizesValuesMap[this.size]] = true;
      }

      if (this.labelClass) {
         this.labelClass.split(' ').forEach((c) => (classNames[c] = true));
      }

      return html`
         <label for=${this.labelFor} class=${classMap(classNames)}>
            ${slotContent}
         </label>
      `;
   }
}
